import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import MenuIcon from '@mui/icons-material/Menu';
import axios from 'axios';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import PDFViewer from './PDFViewer';
import Spinner from 'react-bootstrap/Spinner';
import CustomSpinner from '../components/CustomSpinner';
function Policies({ serverURL, user, setShowSideOverlay }) {


    const [formSectionVisibility, setFormSectionVisibility] = useState("policies")
    const [policies, setPolicies] = useState([])
    const [policyLogs, setPolicyLogs] = useState([])

    const [policyLogsLoading, setPolicyLogsLoading] = useState(true)

    const [policyName, setPolicyName] = useState("");
    const [policyFile, setPolicyFile] = useState(null);
    const [pdfs, setPDFs] = useState(null);
    const [showPDFTitle, setShowPDFTitle] = useState("")

    const [showPDFView, setShowPDFView] = useState()

    const saveThisPolicy = async (e) => {
        e.preventDefault()


        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });

        const base64File = await toBase64(policyFile.files[0]);

        // Create payload
        const payload = {
            data: base64File.split(',')[1], // Exclude "data:<type>;base64,"
            fileName: policyFile.files[0].name,
            fileType: policyFile.files[0].type,
            fileSize: policyFile.files[0].size,
        };

        const query = {
            "userRefId": user._id,
            "name": policyName,
            "file": payload,
            "userRef": user.email,
        }
        console.log(query)

        const saveThePolicy = await axios.post(serverURL + "/policies/add", query)
        if (saveThePolicy.status === 200) {
            console.log(saveThePolicy.data)

            const uniqueId = uuidv4().replaceAll("-", "")

            const logData = {
                "data": saveThePolicy.data,
                "uid": uniqueId,
                "time": dayjs().valueOf(),
                "domain": window.location.origin,
                "updatedBy": {},
                "userRefId": saveThePolicy.data.userRefId,
                "useremail": saveThePolicy.data.createdBy,
                "eventType": "New Policy",
                "policyRefId": saveThePolicy.data._id,
                "status": "pending",
            }


            const createNewLogPermission = await axios.post(serverURL + "/policyLogs/createAction", logData)
            if (createNewLogPermission.status === 200) {
                e.target.reset()
                getAllPolicies()
                getAllPolicyLogs()
            } else {
                console.log(createNewLogPermission.data)
            }

        } else {
            console.log(saveThePolicy.data)
        }
    }

    const getAllPolicies = async () => {
        const getPolicies = await axios.post(serverURL + "/policies/getAll");

        if (getPolicies.status === 200) {
            const activePDFs = getPolicies.data.filter((policy) => { return policy.status === "active" })
            setPolicies(activePDFs)
        } else {
            console.log("no data was available")
        }
    }

    const getAllPolicyLogs = async () => {
        setPolicyLogsLoading(true)
        const getPolicyLOgs = await axios.post(serverURL + "/policyLogs/getAllLogs");

        if (getPolicyLOgs.status === 200) {
            setPolicyLogs(getPolicyLOgs.data)
            setPolicyLogsLoading(false)
        } else {
            console.log("no data was available")
            setPolicyLogsLoading(false)
        }
    }

    const getPDFNow = async (uid, title) => {
        const allIds = [uid]
        setShowPDFView(true)
        setShowPDFTitle(title)

        const getFiles = await axios.post(serverURL + "/policies/getPolicyFile", { "ids": allIds })

        if (getFiles.status === 200) {
            setPDFs(getFiles.data)
        } else {
            console.log(getFiles.data)
        }
    }

    useEffect(() => {
        getAllPolicies()
        getAllPolicyLogs()
    }, [])
    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Policies</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='w-100 h-100 overflow-auto d-flex flex-column'>
                    <Tabs
                        defaultActiveKey="policies"
                        id="uncontrolled-tab-example"
                        className="pt-3 px-3 sticky-top"
                        // fill
                        activeKey={formSectionVisibility}
                        onSelect={(k) => { setFormSectionVisibility(k); }}
                    >
                        <Tab eventKey="policies" title="Policies" className={`p-0 ${formSectionVisibility === "policies" ? "h-100" : ""}`}>
                            {
                                <div className='p-3 h-100 w-100 overflow-auto'>
                                    <div className="containter">
                                        <div className="row">
                                            {
                                                policies.length > 0 ?
                                                    policies.map((policy, key) => {
                                                        return (
                                                            <div key={key} className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-3">
                                                                <div className="card" onClick={(e) => { getPDFNow(policy.files[0].refId, policy.name) }}>
                                                                    <div className="card-header"><span style={{ fontWeight: "700" }}>{policy.name}</span></div>
                                                                    <div className="card-body">{policy.createdBy}</div>
                                                                    <div className="card-footer">
                                                                        <p className='p-0 m-0 text-secondary' style={{ fontSize: ".8rem" }}>Published On: {dayjs(policy.createdAt).format("DD MMM YYYY, hh:mma")}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <div className="col">
                                                        <div className="glassInfo text-center">No Policies for now</div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </Tab>
                        {
                            user.permissions ?
                                user.permissions.filter((permission) => { return permission.value.includes("Policy-Create") }).length > 0 ?
                                    <Tab eventKey="newPolicy" title="New Policy" className={`p-0 ${formSectionVisibility === "newPolicy" ? "h-100" : ""}`}>
                                        {
                                            <div className='w-100 d-flex justify-content-center p-4'>
                                                <form onSubmit={(e) => { saveThisPolicy(e) }} action="" className='d-flex flex-column gap-3 align-items-center bg-light p-4 rounded' style={{ maxWidth: "400px" }}>
                                                    <label htmlFor="" className='w-100'>
                                                        Policy Name:
                                                        <input className='form-control w-100' required type="text" placeholder='' onInput={(e) => { setPolicyName(e.target.value) }} />
                                                    </label>
                                                    <label htmlFor="" className='w-100'>
                                                        File:
                                                        <input className='form-control w-100' type="file" accept='.doc, .docx,.ppt, .pptx,.txt,.pdf' onChange={(e) => { setPolicyFile(e.target) }} />
                                                    </label>
                                                    <div className='w-100 d-flex justify-content-center'>
                                                        <button className='btn btn-sm btn-success rounded-pill px-4'>Send for Approval</button>
                                                    </div>
                                                </form>
                                            </div>
                                        }
                                    </Tab>
                                    :
                                    ""
                                :
                                ""
                        }

                        {
                            user.permissions ?
                                user.permissions.filter((permission) => { return permission.value.includes("Policy-Logs") }).length > 0 ?
                                    <Tab eventKey="logs" title="Logs" className={`p-0 ${formSectionVisibility === "logs" ? "h-100" : ""}`}>
                                        <div className='p-3 h-100 w-100 overflow-auto'>
                                            <div className="containter">
                                                <div className="row">
                                                    <div className="col-12">
                                                        {
                                                            !policyLogsLoading ?
                                                                policyLogs.length > 0 ?
                                                                    <table className='table table-bordered mb-0'>
                                                                        <thead className='table-dark sticky-top'>
                                                                            <tr align="center" valign="middle">
                                                                                <th>#</th>
                                                                                <th className='text-nowrap'>Policy Name</th>
                                                                                <th className='text-nowrap'>Request Date</th>
                                                                                <th className='text-nowrap'>Request By</th>
                                                                                <th className='text-nowrap'>Status</th>
                                                                                <th className='text-nowrap'>Action Taken By</th>
                                                                                <th className='text-nowrap'>Action Taken On</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <thead>
                                                                            {

                                                                                policyLogs.map((log, key) => {
                                                                                    return (
                                                                                        <tr align="center" key={key} valign="middle">
                                                                                            <td>{key + 1}</td>
                                                                                            <td className='text-capitalize'>
                                                                                                {log.data.name}
                                                                                            </td>

                                                                                            <td>{dayjs(log.createdAt).format("DD MMM YYYY, HH:mm:ss")}</td>
                                                                                            <td>{log.useremail}</td>
                                                                                            <td style={{ fontSize: "1.2rem" }}>
                                                                                                {
                                                                                                    log.status === "approved" ?
                                                                                                        <i className='fa fa-check'></i>
                                                                                                        :
                                                                                                        log.status === "pending" ?
                                                                                                            <i className='fa fa-clock'></i>
                                                                                                            :
                                                                                                            log.status === "rejected" ?
                                                                                                                <i className='fa fa-times'></i>
                                                                                                                :
                                                                                                                <i className='fa fa-check'></i>

                                                                                                }
                                                                                            </td>
                                                                                            <td>{log.status !== "pending" ? log.updatedBy?.name : "..."}</td>
                                                                                            <td>{log.status !== "pending" ? dayjs(log.updatedAt).format("DD MMM YYYY, HH:mm:ss") : "..."}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </thead>
                                                                    </table>
                                                                    :
                                                                    <div className="glassInfo text-center">No policy logs for now</div>
                                                                :
                                                                <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-2'>
                                                                    <CustomSpinner size={1} />
                                                                    <span className='text-light fs-6'>Getting Policy Logs</span>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    :
                                    ""
                                :
                                ""
                        }
                    </Tabs>
                </div>
            </div>
            {/*############################## PDF Preview ###############################*/}
            <Modal
                show={showPDFView}
                size='lg'
                backdrop="static"
                onHide={() => {
                    setShowPDFView(false);
                    setPDFs(null);
                    setShowPDFTitle("")
                }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            {showPDFTitle}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        {
                            pdfs ?
                                pdfs.map((pdf, key) => {
                                    return (
                                        <PDFViewer key={key} base64Data={pdf.files[0].data} />
                                    )
                                })
                                :
                                <CustomSpinner size={1}/>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>

        </>
    )
}

export default Policies